import { HomeRankingProductTabsForm } from "./home-ranking-product-tabs-form";
import { HomeRankingProductTabsHandler } from "./home-ranking-product-tabs-handler";
import { HomeRankingProductTabsListener } from "./home-ranking-product-tabs-listener";

export class HomeRankingProductTabsSetup {
    private readonly root: HTMLElement;

    private readonly form: HomeRankingProductTabsForm;

    private readonly handler: HomeRankingProductTabsHandler;

    private readonly listener: HomeRankingProductTabsListener;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new HomeRankingProductTabsForm(root);
        this.handler = new HomeRankingProductTabsHandler(this.form);
        this.listener = new HomeRankingProductTabsListener(this.form, this.handler);
    }

    public init(): void {
        if (!(this.root instanceof HTMLElement)) return;
        if (this.form.isInitialized()) return;

        this.form.markInitialized();
        this.listener.register();
        this.handler.bootstrap();
    }

    public static init(rootEl?: ParentNode | Document | HTMLElement): void {
        const root = rootEl || document;
        if (!(root instanceof Document || root instanceof HTMLElement)) return;

        HomeRankingProductTabsForm.getRoots(root).forEach((node) => {
            const instance = new HomeRankingProductTabsSetup(node);
            instance.init();
        });
    }
}
